<template>
  <!--
        作者：gmshop
        时间：2020-04-25
        描述：插件中心-首页推送
    -->
  <div class="pb50">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="预约取消订单时间">
        <el-input v-model="form.cancel_time" type="number" class="max-w460"></el-input>
        <span class="ml10">小时</span>
        <div class="tips">预约前多久可以取消订单</div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper"><el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button></div>
    </el-form>

  </div>
</template>
<script>
import ServiceApi from '@/api/service.js';
export default {
  data() {
    return {
      form: {
        cancel_time: 0.5,
      },
      /*是否加载完成*/
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {

    /*获取数据*/
    getData() {
      let self = this;
      ServiceApi.getSetting()
        .then(data => {
          self.form = data.data.vars.values;
        })
        .catch(error => {});
    },

    /*提交*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      ServiceApi.editSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getData();
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },
  }
};
</script>

<style>
.reward-list .reward-item {
  margin-bottom: 10px;
  padding: 10px 20px;
  border: 1px solid #ebeef5;
}

.reward-list .delete-reward {
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/views/service/setting/Setting.vue